module.exports = __webpack_public_path__ + "static/media/contact.5dd58622.png";